<!-- 产业服务-物流需求 -->
<template>
<div class="info-block">
  <router-link :to="{path: '/sggqDetail'}" class="info-block-a">
    <div class="div-1">
      <div class="div-1-4">
        <table class="div-1-4-table" cellpadding="0" cellspacing="0" border="0px">
          <tr>
            <td class="td-title">装货地</td>
            <td class="td-title">运输品类</td>
            <td class="td-title">期望装货时间</td>
            <td class="td-title"></td>
          </tr>
          <tr>
            <td class="td-value address">{{info.from_address}}</td>
            <td class="td-value">{{info.goods_category}}</td>
            <td class="td-value" colspan="2">{{info.start_time}}</td>
          </tr>
          <tr>
            <td class="td-title">卸货地</td>
            <td class="td-title">车长</td>
            <td class="td-title">车型</td>
            <td class="td-title">价格</td>
          </tr>
          <tr>
            <td class="td-value address">{{info.to_address}}</td>
            <td class="td-value">{{info.truck_long}}</td>
            <td class="td-value">{{info.truck_type}}</td>
            <td class="td-value price">￥{{info.price}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <a class="td-action-1">了解详情</a>
        <a class="td-action-2">联系方式：137****2547<br>（登录即可查看完整号码）</a>
      </div>
    </div>


  </router-link>
</div>
</template>

<script>
export default {
  name: 'CyfwInfo4',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:120px;
  padding:0px;
  margin:0px 1px 20px 0px;
  background-color: #F6F8F9;
  border:1px solid #ddd;
  background-size: 50px 50px;
  background-repeat: no-repeat;
  background-position: 10px 5px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px #eee;
}

.div-1{
  position:relative;
  height:120px;
  width:100%;
  padding:0px 0px 0px 28px;
  //background:#green;
  background-image:url(./../../assets/wl_01.png);
  background-size: 17px 80px;
  background-repeat: no-repeat;
  background-position: 10px 12px;
}

.div-1-4{
  position:relative;
  height:120px;
  //background:green;
  text-align:left;
  color:#888;
  padding:0px 160px 0px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:140px;
  height:20px;
  line-height:20px;
  color:#888;
  padding-top:10px;
}

.div-1-4-table .td-value{
  text-align:left;
  width:140px;
  height:20px;
  font-size:12px;
  font-weight:600;
  line-height:20px;
  color:#000;
}

.div-1-4-table .address{
  font-size:14px;
}

.div-1-4-table .price{
  color:red;
}

.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:160px;
  margin:0px;
  //background:green;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin:20px auto;
  border:1px solid var(--color7);
  color:#888;
  line-height:20px;
  text-align:center;
  //background:yellow;
}

.div-3 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}

.div-3 .td-action-2{
  display:block;
  width:160px;
  padding:0px;
  margin:0px;
  color:#888;
  line-height:20px;
  text-align:center;
  //background:yellow;
}

</style>



// WEBPACK FOOTER //
// src/components/module/CyfwInfo4.vue